import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pageAction } from '../redux_files/actions/page_actions';
import Accordion from '../components/accordion';
import questions from '../json_config/faq.json';

const FAQ = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Frequently asked questions';
    dispatch(pageAction('Frequently asked questions'));
  });
  return (
    <>
      <div className='container'>
        <div className='aboutus outer-border pd-20'>
          As a cusomer we can have so many questions about our order and refunds.
          Here we are going to answer most of the general asked questions:
          <Accordion accordionData={Array.from(questions)} />
          Still confused or have some feedback please call us or whats app us at <a href='tel:+919996212490'>9996212490</a>
          <br />
        </div>
      </div>
    </>
  );
};

export default FAQ;
